<template>
  <div>
    <div class="modal fade" :id="nomeModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-scrollable" role="document" :class="classModal">
        <div class="modal-content">
          <div class="modal-header">
            <span>{{ header }}</span>
            <button type="button" class="close" @click="fechar()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <div
              class="d-inline-flex flex-row-reverse justify-content-between w-100 align-items-center"
            >
              <div>
                <button type="button" class="btn btn-danger mr-2" v-if="poderemover" @click="remover()">Remover</button>
                <button type="button" class="btn btn-secondary mr-2" @click="fechar()">Fechar</button>
                <button type="button" class="btn btn-success" @click="imprimirConteudo">{{acao}}</button>
              </div>

              <div class="d-flex flex-row align-items-center">
                <!-- Page Size -->
                <div class="form-group mb-0" v-if="pageSelect">
                  <select
                    class="form-control"
                    id="page-size"
                    type="select"
                    v-model="dados.pageSize"
                  >
                    <option value="A4">A4</option>
                    <option value="A4-T">A4 (Timbrado)</option>
                    <option value="A4-NT">A4 (Não Timbrado)</option>
                    <option value="A5">A5</option>
                    <option value="A5-T">A5 (Timbrado)</option>
                    <option value="A5-NT">A5 (Não Timbrado)</option>
                  </select>
                </div>
                <!-- Kit -->
                <div v-if="kit" class="mx-4">
                  <div>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="dados.salvarKit"
                      id="check-kit"
                    />
                    <label class="form-check-label" for="check-kit">Salvar como Kit</label>
                  </div>
                </div>
                <!-- Agrupado -->
                <div v-if="agrupada" class="mx-4">
                  <div>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="dados.impressaoAgrupada"
                      id="check-group"
                    />
                    <label class="form-check-label" for="check-group">Impressão Agrupada</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      dados: {
        pageSize: "A4",
        salvarKit: false,
        impressaoAgrupada: false
      }
    };
  },
  methods: {
    fechar() { 
      $('#' + this.nomeModal).modal('hide');
    },
    abrirModalImpressao() {
      $("#" + this.nomeModal).modal("show");
    },
    fecharModalImpressao() {
      this.$emit("fechar");
      $("#" + this.idModal).modal("close");
    },
    imprimirConteudo() {
      if (this.pageSelect && this.dados.pageSize) {
        localStorage.pageSize = this.dados.pageSize;
        this.$util.setCookie('page-size', this.dados.pageSize ? this.dados.pageSize : 'A4');
      }
      this.$emit("acao", this.dados);
    },
    remover() { 
      this.$emit('remover');
    }
  },
  computed: {
    classModal: function() {
      if (this.size == "xl") {
        return " modal-xl";
      } else if (this.size == "lg") {
        return " modal-lg";
      } else if (this.size == "sm") {
        return " modal-sm";
      }
      return " modal-dialog2";
    },
    nomeModal() {
      let newId = this.$util.gerarRandomString(9, this.idModal);
      return newId;
    }
  },
  props: {
    header: {
      type: String,
      default: "Impressão"
    },
    pageSelect: {
      type: Boolean,
      default: false
    },
    idModal: {
      type: String,
      default: "Modal123"
    },
    size: {
      type: String,
      default: ""
    },
    acao: {
      type: String,
      default: "Imprimir"
    },
    kit: {
      type: Boolean,
      default: false
    },
    agrupada: {
      type: Boolean,
      default: false
    },
    poderemover: { 
      type: Boolean,
      default: false
    }
  },
  watch: {
    dados: {
      handler(newDados) {
        this.$emit("changedata", newDados);
      },
      deep: true
    }
  },
  beforeMount() {},
  mounted() {
    this.dados.pageSize = this.$util.getCookie('page-size') ? this.$util.getCookie('page-size') : 'A4';
    /*
    if (localStorage.pageSize) {
      this.dados.pageSize = localStorage.pageSize;
      // this.idModal = this.gerarIdModal();
    }
    */
  }
};
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>